import { axiosDS } from '@pp/axios'
import { urls } from 'Constants/Urls'
import { UserSettingModel } from 'Modules'

export const emailApi = async (url: string, email_confirmation_code?: string, data?: any) => {
	const res = await (email_confirmation_code
		? axiosDS({
				extendHeaders: {
					EmailConfirmationCode: email_confirmation_code?.replace(/[а-яёА-ЯЁ]/g, ''),
				},
		  })
		: axiosDS()
	).post<UserSettingModel>(url, { data })

	return res.data
}

export const postEmailConfirmation = async (scope: string, email?: string) => {
	const data = { data: { scope, email } }
	const res = await axiosDS().post(urls.common.email.email_confirmation, data)

	return res.data
}
